import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_zrsvmzuev5: FaireCollectionEntity = {
  token: "pbc_zrsvmzuev5",
  type: "collection",
  name: "Moon & Stars Dream Jacquard Knit Baby Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/30a63d916586635c3d542549e9a1c825d43bb9c5931c7f30b2a6c4c2689183b2.png",
  itemCount: 2,
  description:
    "Wrap your little one in celestial comfort with our Moon & Stars Dream Organic Baby Jacquard Knit collection, thoughtfully crafted from soft, breathable certified organic cotton that is gentle on delicate newborn skin. Ethically made in India.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:15.789Z",
    importedBy: "entity-db-import-collections",
  },
};
